import React, { useEffect } from "react";
import Rotas from "./components/main/Routes";
import styled from "styled-components";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";

import { AuthProvider } from "./components/context/AuthContext";
import theme from "./components/theme/Theme";
import { restoreSession } from "./components/api/services/AuthService";
import GlobalStyle from "./GlobalStyle";
import { ThemeProvider } from '@mui/material/styles';


const MainSection = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
`;

function App() {
  useEffect(() => {
    restoreSession();
  }, []);

return (
        <MainSection className="main-section">
            <ThemeProvider theme={theme}>
              <AuthProvider>
                <GlobalStyle />
                <Rotas />
              </AuthProvider>
            </ThemeProvider>
        </MainSection>
    );
}

export default App;
